<div class="clr-row clr-justify-content-center margin-0">
  <div class="clr-col-xl-9 clr-col-lg-10 clr-col-md-11 clr-col-sm-12">
    <div class="clr-row clr-justify-content-center">
      <div class="clr-col-12 comparebox spacing-top">
        <div class="clr-row">
          <div class="clr-col-lg-6 clr-col-md-6 clr-col-12">
            <div *ngIf="selectedUser1 != null" class="card">
              <div class="card-block">
                <div class="card-title">
                  {{ selectedUser1.firstName }} {{ selectedUser1.lastName }}
                </div>
                <div class="card-text">
                  {{ selectedUser1.email }}
                </div>
              </div>
              <div class="card-footer">
                <a (click)="unselectCustomer(selectedUser1)"
                   class="no-underline">
                  {{ __('action.comparisonunselect') }}
                </a>
              </div>
            </div>
            <div *ngIf="selectedUser1 == null && selectedUser2 != null && selectedUser2.keycloakId !== userId && masterHasTest && !isMasterSelected()"
                 class="card selfselect">
              <div class="card-block">
                <div class="card-title">
                  {{ name }}
                </div>
                <div class="card-text">
                  &nbsp; <!-- Placeholder for consistent height -->
                </div>
              </div>
              <div class="card-footer">
                <a (click)="selectMaster()"
                   class="no-underline">
                  {{ __('action.selfcompare') }}
                </a>
              </div>
            </div>
            <div *ngIf="selectedUser1 == null && !(masterHasTest && !isMasterSelected())"
                 class="card-placeholder"></div>
          </div>

          <div class="clr-col-lg-6 clr-col-md-6 clr-col-12">
            <div *ngIf="selectedUser2 != null" class="card">
              <div class="card-block">
                <div class="card-title">
                  {{ selectedUser2.firstName }} {{ selectedUser2.lastName }}
                </div>
                <div class="card-text">
                  {{ selectedUser2.email }}
                  <ng-container *ngIf="!selectedUser2.email">&nbsp;</ng-container>
                </div>
              </div>
              <div class="card-footer">
                <a (click)="unselectCustomer(selectedUser2)"
                   class="no-underline">
                  {{ __('action.comparisonunselect') }}
                </a>
              </div>
            </div>
            <div
              *ngIf="selectedUser2 == null && selectedUser1 != null && selectedUser1.keycloakId !== userId && masterHasTest && !isMasterSelected()"
              class="card selfselect">
              <div class="card-block">
                <div class="card-title">
                  {{ name }}
                </div>
                <div class="card-text">
                  &nbsp;
                </div>
              </div>
              <div class="card-footer">
                <a (click)="selectMaster()"
                   class="no-underline">
                  {{ __('action.selfcompare') }}
                </a>
              </div>
            </div>
            <div
              *ngIf="selectedUser2 == null && !(selectedUser1 != null && selectedUser1.keycloakId !== userId && masterHasTest && !isMasterSelected())"
              class="card-placeholder"></div>
          </div>
        </div>

        <div class="clr-row clr-justify-content-center compareaction">
          <div *ngIf="bothSelected()" class="clr-col-12 action">
            <button (click)="compare()" class="id37-btn-outline" type="button">
              {{ __('action.compareaction') }}
            </button>
          </div>
        </div>
      </div>

      <div class="clr-col-12 spacing-top">
        <div class="existing-and-search-container">
            <div class="clr-col-6" id="existing-clients-second-header">
              <h3>
                {{ __('existingClients') }} ({{ totalCustomerCount }})
              </h3>
            </div>
            <div class="clr-col search-input-container">
              <input [(ngModel)]="searchInput"
                     (ngModelChange)="searchCustomers()"
                     maxlength="100"
                     placeholder="{{ __('search') }}">
              <button *ngIf="searchInput.length > 0"
                      (click)="clearSearchInput()"
                      class="id37-btn id37-btn-sm id37-btn-secondary">
                <img alt="clear" id="search-x" src="assets/icons/ID37_X.svg"/>
              </button>
              <button *ngIf="searchInput.length === 0"
                      class="id37-btn id37-btn-sm id37-btn-secondary" id="search-button">
                <img alt="search" src="assets/icons/arrow_link_12x12.svg">
              </button>
            </div>
        </div>

        <clr-datagrid class="my-customers-datagrid"
                      [clrDgLoading]="loading"
                      (clrDgRefresh)="refresh($event)">

          <clr-dg-column [clrDgField]="'name'"
                         class="datagrid-column-header">{{ __('name') }}
          </clr-dg-column>
          <clr-dg-column [clrDgField]="'GROUP'"
                         class="datagrid-column-header">{{ __('group') }}
          </clr-dg-column>
          <clr-dg-column [clrDgField]="'DATE'"
                         class="datagrid-column-header">{{ __('date') }}
          </clr-dg-column>
          <clr-dg-column [clrDgField]="'PRODUCT'"
                         class="datagrid-column-header">{{ __('variation') }}
          </clr-dg-column>
          <clr-dg-column [clrDgField]="'ACTION'"
                         class="datagrid-column-header">{{ __('action') }}
          </clr-dg-column>

          <clr-dg-row *ngFor="let customer of customers">
            <clr-dg-cell>
              <div class="name-container">
                <p>{{ customer.firstName }} {{ customer.lastName }}</p>
                <p class="email">{{ customer.email }}</p>
              </div>
            </clr-dg-cell>
            <clr-dg-cell>
              <ng-container *ngIf="customer.groupName; else noGroup">
                {{ customer.groupName }}
              </ng-container>
              <ng-template #noGroup>
                <div class="no-group-label">
                  {{ __('group.no-group-label') }} <!-- Shared key -->
                </div>
              </ng-template>
            </clr-dg-cell>
            <clr-dg-cell>{{ customer.creationDate | date }}</clr-dg-cell>
            <clr-dg-cell>{{ __(customer.getVariationOfFirstTest()) }}</clr-dg-cell>
            <clr-dg-cell id="customer-action-container">
              <button *ngIf="!isSelected(customer) && canSelectMore() && customer.hasFinishedTests()"
                      (click)="toggleSelection(customer)"
                      class="id37-btn-outline id37-btn-sm id37-btn-rounded-2 modal-button"
                      title="{{__('action.comparisonselect')}}">
                <clr-icon shape="plus"></clr-icon>
              </button>
              <button *ngIf="isSelected(customer)"
                      (click)="unselectCustomer(customer)"
                      class="id37-btn id37-btn-sm id37-btn-secondary id37-btn-rounded-2 modal-button"
                      title="{{__('action.comparisonunselect')}}">
                <clr-icon shape="minus"></clr-icon>
              </button>
              <div *ngIf="!isSelected(customer) && !customer.hasFinishedTests()" class="inactive-button">
                {{ __('testNotFinished') }}
              </div>
              <div *ngIf="!isSelected(customer) && !canSelectMore() && customer.hasFinishedTests()"
                   class="inactive-button">
                {{ __('maxSelectionsReached') }}
              </div>
            </clr-dg-cell>
          </clr-dg-row>

          <clr-dg-placeholder>{{ __('noCustomersFound') }}</clr-dg-placeholder>

          <clr-dg-footer>
            <clr-dg-pagination id="pagination-container" #pagination
                               [clrDgPageSize]="10"
                               [clrDgTotalItems]="totalCustomerCount">
              <clr-dg-page-size [clrPageSizeOptions]="[10,20,50,100]">
                <div id="customer-number-selection-label">
                  {{ __('customers') }}
                </div>
              </clr-dg-page-size>
              {{ pagination.firstItem + 1 }} - {{ pagination.lastItem + 1 }}
              {{ __('of') }} {{ totalCustomerCount }} {{ __('customers') }}
            </clr-dg-pagination>
          </clr-dg-footer>
        </clr-datagrid>
      </div>
    </div>
  </div>
</div>
